import { GetGS1DataResponse } from 'api/models/Implants';
import ApiClientBase from './ApiClientBase';
import { IMPLANT_KITTING_FEATURE_FLAG } from 'featureFlags';

class ImplantsEndpoint extends ApiClientBase {
  apiUri = '/api/v2/implants';

  getGS1ImplantData({ barcode, tenantName }: { barcode: string; tenantName?: string }) {
    let url = `/gs1_data/?barcode=${barcode}`;

    // If the IMPLANT_KITTING_FEATURE_FLAG is enabled, attach the tenant name to the request and ensure it's present
    if (IMPLANT_KITTING_FEATURE_FLAG) {
      if (!tenantName) {
        throw new Error('Tenant name is required');
      }

      url += `&tenant_name=${tenantName}`;
    }

    return this.apiCall<GetGS1DataResponse>(url, 'get');
  }
}

const implants = new ImplantsEndpoint();
export default implants;
